<template>
  <!-- 按钮文字
       @author: liuguisheng
       @date: 2020-4-21
   -->
  <div class="setting-item">
    <el-form-item label="透明占位"> 
      <el-input v-model="seat" 
                placeholder='请输入占位文字'></el-input>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 透明占位
     *  @description 将 seat 字段映射到当前 seat 计算属性
     *  @return {String}
     *  @author liuguisheng
     *  @version 2020-4-21
     */
    ...mapComputed({
      seat: { 
        parent: i => i.renderOption,
        attr: "seat" 
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderSeat.vue